export interface Annotation {
  id: string;
  text: string;
  entity: EntityType;
  position: {
    pageNumber: number;
    top: number;
    left: number;
    width: number;
    height: number;
  };
}

export type EntityType =
  | "GENE"
  | "DISEASE"
  | "CHEMICAL"
  | "SPECIES"
  | "MUTATION"
  | "CELL_LINE"
  | "CELL_TYPE"
  | "DNA"
  | "RNA"
  | "DRUG"
  | "UNKNOWN"
  | "ADC"
  | "ANTIBODY"
  | "LINKER"
  | "THERAPEUTIC_MODALITY"
  | "THERAPEUTIC_MODALITY_TARGET_INDICATION"
  | "THERAPEUTIC_MODALITY_THERAPEUTIC_WARHEAD"
  | "THERAPEUTIC_MODALITY_RELEVANT_BIOLOGY"
  | "THERAPEUTIC_MODALITY_DOSING_INFORMATION"
  | "MANUFACTURING";

export const entityTypes: EntityType[] = [
  "GENE",
  "DISEASE",
  "CHEMICAL",
  "SPECIES",
  "MUTATION",
  "CELL_LINE",
  "CELL_TYPE",
  "DNA",
  "RNA",
  "DRUG",
  "ADC",
  "ANTIBODY",
  "LINKER",
  "THERAPEUTIC_MODALITY",
  "THERAPEUTIC_MODALITY_TARGET_INDICATION",
  "THERAPEUTIC_MODALITY_THERAPEUTIC_WARHEAD",
  "THERAPEUTIC_MODALITY_RELEVANT_BIOLOGY",
  "THERAPEUTIC_MODALITY_DOSING_INFORMATION",
  "MANUFACTURING",
];

export const ENTITY_COLORS: Record<EntityType, string> = {
  GENE: "rgba(255, 182, 193, 0.5)", // Pink
  DISEASE: "rgba(173, 216, 230, 0.5)", // Light blue
  CHEMICAL: "rgba(144, 238, 144, 0.5)", // Light green
  SPECIES: "rgba(255, 218, 185, 0.5)", // Peach
  MUTATION: "rgba(216, 191, 216, 0.5)", // Light purple
  CELL_LINE: "rgba(255, 255, 153, 0.5)", // Light yellow
  CELL_TYPE: "rgba(255, 160, 122, 0.5)", // Light salmon
  DNA: "rgba(175, 238, 238, 0.5)", // Light cyan
  RNA: "rgba(221, 160, 221, 0.5)", // Plum
  DRUG: "rgba(135, 206, 250, 0.5)", // Light sky blue
  UNKNOWN: "rgba(211, 211, 211, 0.5)", // Light gray
  ADC: "rgba(255, 228, 196, 0.5)", // Bisque
  ANTIBODY: "rgba(240, 230, 140, 0.5)", // Khaki
  LINKER: "rgba(176, 224, 230, 0.5)", // Powder blue
  THERAPEUTIC_MODALITY: "rgba(255, 222, 173, 0.5)", // Navajo white
  THERAPEUTIC_MODALITY_TARGET_INDICATION: "rgba(216, 250, 232, 0.5)", // Mint
  THERAPEUTIC_MODALITY_THERAPEUTIC_WARHEAD: "rgba(255, 192, 203, 0.5)", // Pink
  THERAPEUTIC_MODALITY_RELEVANT_BIOLOGY: "rgba(230, 230, 250, 0.5)", // Lavender
  THERAPEUTIC_MODALITY_DOSING_INFORMATION: "rgba(250, 250, 210, 0.5)", // Light goldenrod yellow
  MANUFACTURING: "rgba(211, 245, 197, 0.5)", // Light greenish
};

export const ENTITY_BORDER_COLORS: Record<EntityType, string> = {
  GENE: "rgba(219, 112, 147, 0.8)", // Darker pink
  DISEASE: "rgba(70, 130, 180, 0.8)", // Steel blue
  CHEMICAL: "rgba(46, 139, 87, 0.8)", // Sea green
  SPECIES: "rgba(210, 105, 30, 0.8)", // Chocolate
  MUTATION: "rgba(128, 0, 128, 0.8)", // Purple
  CELL_LINE: "rgba(184, 134, 11, 0.8)", // Dark goldenrod
  CELL_TYPE: "rgba(233, 150, 122, 0.8)", // Dark salmon
  DNA: "rgba(0, 139, 139, 0.8)", // Dark cyan
  RNA: "rgba(186, 85, 211, 0.8)", // Medium orchid
  DRUG: "rgba(30, 144, 255, 0.8)", // Dodger blue
  UNKNOWN: "rgba(128, 128, 128, 0.8)", // Gray
  ADC: "rgba(210, 180, 140, 0.8)", // Tan
  ANTIBODY: "rgba(189, 183, 107, 0.8)", // Dark khaki
  LINKER: "rgba(100, 149, 237, 0.8)", // Cornflower blue
  THERAPEUTIC_MODALITY: "rgba(255, 140, 0, 0.8)", // Dark orange
  THERAPEUTIC_MODALITY_TARGET_INDICATION: "rgba(102, 205, 170, 0.8)", // Medium aquamarine
  THERAPEUTIC_MODALITY_THERAPEUTIC_WARHEAD: "rgba(199, 21, 133, 0.8)", // Medium violet red
  THERAPEUTIC_MODALITY_RELEVANT_BIOLOGY: "rgba(148, 0, 211, 0.8)", // Dark violet
  THERAPEUTIC_MODALITY_DOSING_INFORMATION: "rgba(218, 165, 32, 0.8)", // Goldenrod
  MANUFACTURING: "rgba(85, 107, 47, 0.8)", // Dark olive green
};
